var _g, _g2, _path, _path2, _path3, _path4, _path5, _g3, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _g4, _g5, _g6, _g7, _g8, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-ec",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffe800",
    d: "M0 0h512v512H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00148e",
    d: "M0 256h512v256H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#da0010",
    d: "M0 384h512v128H0z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m213.5 244.2-54.7 57.7-1-1.2 54.7-57.8 1 1.3zm38 9.4L180 329l-1.2-1.2 71.5-75.4 1.3 1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    stroke: "#000",
    strokeWidth: 4.1,
    d: "M478.4 60.2v88.6l17.7 88.6 17.7-88.6V60.2h-35.4z",
    transform: "matrix(-.052 -.05 -.067 .068 210 348.9)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    stroke: "#000",
    strokeWidth: 4.1,
    d: "M478.4 60.2v88.6l17.7 88.6 17.7-88.6V60.2h-35.4z",
    transform: "matrix(-.052 -.05 -.067 .068 191.6 319.4)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffdf00",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M301.2 272.8s-17.7 336.6 53.1 336.6S460.6 574 460.6 574l-.8-185-158.6-116.2z",
    transform: "matrix(.34 0 0 .486 64.7 -20.5)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0000c4",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M344.5 304.2c0 17.7-7.9 269.8 27.5 269.8s88.6-17.7 88.6-17.7l-.8-167.3-115.3-84.8z",
    transform: "matrix(.34 0 0 .486 64.7 -20.5)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#e10000",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M367.5 321.2c0 17.7 4.5 217.4 40 217.4h53.1l-.8-149.6-92.3-67.8z",
    transform: "matrix(.34 0 0 .486 64.7 -20.5)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m165.7 112.2 54.6 57.7 1-1.2-54.7-57.7-1 1.2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffdf00",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M301.2 272.8S265.8 609.4 372 609.4c88.5 0 88.5-53.1 106.2-53.1l-17.7-124-159.4-159.5z",
    transform: "matrix(.44 0 0 .465 17.3 17)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.3,
    d: "M269.6 155.2c1.1 0 28.3-94 119-147.2",
    transform: "matrix(.29 -.02 -.038 .265 112 135.9)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005b00",
    fillRule: "evenodd",
    strokeWidth: "1pt",
    d: "M421.4-20.3c0 18.1-4.6 31.7-11.4 45.3-5.6-18.1-9-27.2-9-45.3s6.8-35.1 12.4-48.7c2.3 12.4 8 30.5 8 48.7z",
    transform: "matrix(.105 -.166 .22 .105 142.8 218.9)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "red",
    fillRule: "evenodd",
    strokeWidth: "1pt",
    d: "M454.2-169.3c0 4-3.8 7.4-8.5 7.4s-8.5-3.3-8.5-7.4 3.8-7.3 8.5-7.3 8.5 3.3 8.5 7.3z",
    transform: "matrix(.137 -.076 .067 .132 144 218.4)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005b00",
    fillRule: "evenodd",
    strokeWidth: "1pt",
    d: "M421.4-20.3c0 18.1-4.6 31.7-11.4 45.3-5.6-18.1-9-27.2-9-45.3s6.8-35.1 12.4-48.7c2.3 12.4 8 30.5 8 48.7z",
    transform: "matrix(.133 .09 -.096 .25 146.6 97.4)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005b00",
    fillRule: "evenodd",
    strokeWidth: "1pt",
    d: "M421.4-20.3c0 18.1-4.6 31.7-11.4 45.3-5.6-18.1-9-27.2-9-45.3s6.8-35.1 12.4-48.7c2.3 12.4 8 30.5 8 48.7z",
    transform: "matrix(.132 -.023 -.023 .245 145.4 144.9)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005b00",
    fillRule: "evenodd",
    strokeWidth: "1pt",
    d: "M421.4-20.3c0 18.1-4.6 31.7-11.4 45.3-5.6-18.1-9-27.2-9-45.3s6.8-35.1 12.4-48.7c2.3 12.4 8 30.5 8 48.7z",
    transform: "matrix(.048 .19 -.13 .146 182.1 59)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005b00",
    fillRule: "evenodd",
    strokeWidth: "1pt",
    d: "M421.4-20.3c0 18.1-4.6 31.7-11.4 45.3-5.6-18.1-9-27.2-9-45.3s6.8-35.1 12.4-48.7c2.3 12.4 8 30.5 8 48.7z",
    transform: "matrix(.156 -.14 .14 .178 123.4 206.6)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005b00",
    fillRule: "evenodd",
    strokeWidth: "1pt",
    d: "M421.4-20.3c0 18.1-4.6 31.7-11.4 45.3-5.6-18.1-9-27.2-9-45.3s6.8-35.1 12.4-48.7c2.3 12.4 8 30.5 8 48.7z",
    transform: "matrix(.164 -.17 .19 .153 112.3 237.6)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005b00",
    fillRule: "evenodd",
    strokeWidth: "1pt",
    d: "M421.4-20.3c0 18.1-4.6 31.7-11.4 45.3-5.6-18.1-9-27.2-9-45.3s6.8-35.1 12.4-48.7c2.3 12.4 8 30.5 8 48.7z",
    transform: "matrix(.194 .072 -.145 .24 108.7 136.1)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005b00",
    fillRule: "evenodd",
    strokeWidth: "1pt",
    d: "M421.4-20.3c0 18.1-4.6 31.7-11.4 45.3-5.6-18.1-9-27.2-9-45.3s6.8-35.1 12.4-48.7c2.3 12.4 8 30.5 8 48.7z",
    transform: "matrix(.114 .158 -.242 .167 144.8 102.7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005b00",
    fillRule: "evenodd",
    strokeWidth: "1pt",
    d: "M421.4-20.3c0 18.1-4.6 31.7-11.4 45.3-5.6-18.1-9-27.2-9-45.3s6.8-35.1 12.4-48.7c2.3 12.4 8 30.5 8 48.7z",
    transform: "matrix(.06 .066 -.102 .123 199.2 102.1)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005b00",
    fillRule: "evenodd",
    strokeWidth: "1pt",
    d: "M421.4-20.3c0 18.1-4.6 31.7-11.4 45.3-5.6-18.1-9-27.2-9-45.3s6.8-35.1 12.4-48.7c2.3 12.4 8 30.5 8 48.7z",
    transform: "matrix(.08 .004 -.06 .13 189.7 127.6)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005b00",
    fillRule: "evenodd",
    strokeWidth: "1pt",
    d: "M421.4-20.3c0 18.1-4.6 31.7-11.4 45.3-5.6-18.1-9-27.2-9-45.3s6.8-35.1 12.4-48.7c2.3 12.4 8 30.5 8 48.7z",
    transform: "matrix(-.007 .11 -.103 .062 227 85.9)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005b00",
    fillRule: "evenodd",
    strokeWidth: "1pt",
    d: "M421.4-20.3c0 18.1-4.6 31.7-11.4 45.3-5.6-18.1-9-27.2-9-45.3s6.8-35.1 12.4-48.7c2.3 12.4 8 30.5 8 48.7z",
    transform: "matrix(.05 .087 -.19 .115 176.6 111.9)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005b00",
    fillRule: "evenodd",
    strokeWidth: "1pt",
    d: "M421.4-20.3c0 18.1-4.6 31.7-11.4 45.3-5.6-18.1-9-27.2-9-45.3s6.8-35.1 12.4-48.7c2.3 12.4 8 30.5 8 48.7z",
    transform: "matrix(.098 .168 -.252 .15 166.3 77.6)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.4,
    d: "M269.6 155.2c1.1 0 28.3-94 119-147.2",
    transform: "matrix(.266 -.148 .107 .21 94.4 196.6)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "red",
    fillRule: "evenodd",
    strokeWidth: "1pt",
    d: "M454.2-169.3c0 4-3.8 7.4-8.5 7.4s-8.5-3.3-8.5-7.4 3.8-7.3 8.5-7.3 8.5 3.3 8.5 7.3z",
    transform: "matrix(.137 -.076 .067 .132 161.2 194.2)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "red",
    fillRule: "evenodd",
    strokeWidth: "1pt",
    d: "M454.2-169.3c0 4-3.8 7.4-8.5 7.4s-8.5-3.3-8.5-7.4 3.8-7.3 8.5-7.3 8.5 3.3 8.5 7.3z",
    transform: "matrix(.137 -.076 .067 .132 169.4 189.4)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "red",
    fillRule: "evenodd",
    strokeWidth: "1pt",
    d: "M454.2-169.3c0 4-3.8 7.4-8.5 7.4s-8.5-3.3-8.5-7.4 3.8-7.3 8.5-7.3 8.5 3.3 8.5 7.3z",
    transform: "matrix(.14 -.08 .05 .1 136 200.3)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "red",
    fillRule: "evenodd",
    strokeWidth: "1pt",
    d: "M454.2-169.3c0 4-3.8 7.4-8.5 7.4s-8.5-3.3-8.5-7.4 3.8-7.3 8.5-7.3 8.5 3.3 8.5 7.3z",
    transform: "matrix(.14 -.08 .05 .1 138.3 199.3)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "red",
    fillRule: "evenodd",
    strokeWidth: "1pt",
    d: "M454.2-169.3c0 4-3.8 7.4-8.5 7.4s-8.5-3.3-8.5-7.4 3.8-7.3 8.5-7.3 8.5 3.3 8.5 7.3z",
    transform: "matrix(.14 -.08 .05 .1 137 201.4)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "red",
    fillRule: "evenodd",
    strokeWidth: "1pt",
    d: "M454.2-169.3c0 4-3.8 7.4-8.5 7.4s-8.5-3.3-8.5-7.4 3.8-7.3 8.5-7.3 8.5 3.3 8.5 7.3z",
    transform: "matrix(.152 -.084 .074 .147 145 210.7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "red",
    fillRule: "evenodd",
    strokeWidth: "1pt",
    d: "M454.2-169.3c0 4-3.8 7.4-8.5 7.4s-8.5-3.3-8.5-7.4 3.8-7.3 8.5-7.3 8.5 3.3 8.5 7.3z",
    transform: "matrix(.152 -.084 .074 .147 146.7 209)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "red",
    fillRule: "evenodd",
    strokeWidth: "1pt",
    d: "M454.2-169.3c0 4-3.8 7.4-8.5 7.4s-8.5-3.3-8.5-7.4 3.8-7.3 8.5-7.3 8.5 3.3 8.5 7.3z",
    transform: "matrix(.152 -.084 .074 .147 147.1 209.8)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#0000c4",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M336.6 308.3c0 17.7-35.4 212.6 53.2 265.7 35.4 17.7 88.5-17.7 88.5 0l-17.7-141.7-124-124z",
    transform: "matrix(.44 0 0 .465 17.3 17)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#e10000",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M372 343.7c0 17.7-17.7 159.4 35.5 194.9 35.4 35.4 124 25.8 124 25.8l-70.9-132.1-88.6-88.6z",
    transform: "matrix(.44 0 0 .465 17.3 17)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m148.8 144 71.5 75.4 1.3-1.2-71.6-75.4-1.2 1.2z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#cececc",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "m460.6 184.3 17.7 35.4v17.7c-.8-1.3 0 17.7-17.7 17.7S443 219.7 443 219.7s-17.7 35.4-17.7 70.9 17.7 53.1 17.7 53.1-2.6-36.7 17.7-35.4c20.4 1.2 17.7 17.7 17.7 17.7v35.4h17.8V219.7l17.7-35.4-27.2-53.2-26 53.1z",
    transform: "matrix(.102 -.107 .08 .082 75.2 169.7)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#cececc",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "m557.8 95.7-26.3 70.8 17.7 53.2-35.4-17.7 35.4 53.1v35.5H567V255l35.5-53.1-35.5 17.7 17.8-53.2-26.9-70.8z",
    transform: "matrix(.08 -.12 .105 .07 96 163.4)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#e10000",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M422.5 137c0 2-2 3.7-4.3 3.7s-4.4-1.7-4.4-3.7 2-3.8 4.4-3.8 4.3 1.7 4.3 3.8zm-6.2 7.9c0 35.8 20.9 187.8 22.6 191.5.1 4.5-4.8 6.4-7.1.9-6.6-17.4-20.8-160-21.3-193.3-.3-13.7 3.7-14.8 8.3-14.5 3.7.2 8.3 3.7 8.3 7.9 0 5-5.8 8.7-10.8 7.5z",
    transform: "matrix(.303 0 0 .234 43 77.3)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#0000c4",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M422.5 137c0 2-2 3.7-4.3 3.7s-4.4-1.7-4.4-3.7 2-3.8 4.4-3.8 4.3 1.7 4.3 3.8zm-6.2 7.9c31.5 61.4 48.7 166.7 50.4 170.5.1 4.4-4.8 6.4-7.1.8-2.5-3.3-12.7-100.2-49.1-172.2-.3-13.7 3.7-14.8 8.3-14.5 3.7.2 8.3 3.7 8.3 7.9 0 5-5.8 8.7-10.8 7.5z",
    transform: "matrix(.285 .07 -.114 .22 67.4 53.5)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#e10000",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M422.5 137c0 2-2 3.7-4.3 3.7s-4.4-1.7-4.4-3.7 2-3.8 4.4-3.8 4.3 1.7 4.3 3.8zm-6.2 7.9c0 35.8 20.9 187.8 22.6 191.5.1 4.5-4.8 6.4-7.1.9-6.6-17.4-20.8-160-21.3-193.3-.3-13.7 3.7-14.8 8.3-14.5 3.7.2 8.3 3.7 8.3 7.9 0 5-5.8 8.7-10.8 7.5z",
    transform: "matrix(.387 0 0 .38 -8.6 87.3)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#0000c4",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M422.5 137c0 2-2 3.7-4.3 3.7s-4.4-1.7-4.4-3.7 2-3.8 4.4-3.8 4.3 1.7 4.3 3.8zm-6.2 7.9c31.5 61.4 48.7 166.7 50.4 170.5.1 4.4-4.8 6.4-7.1.8-2.5-3.3-12.7-100.2-49.1-172.2-.3-13.7 3.7-14.8 8.3-14.5 3.7.2 8.3 3.7 8.3 7.9 0 5-5.8 8.7-10.8 7.5z",
    transform: "matrix(.365 .112 -.145 .36 22.6 48.5)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m289.6 244.2 54.7 57.7 1-1.2-54.7-57.8-1 1.3zm-38 9.4L323 329l1.2-1.2-71.5-75.4-1.3 1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    stroke: "#000",
    strokeWidth: 4.1,
    d: "M478.4 60.2v88.6l17.7 88.6 17.7-88.6V60.2h-35.4z",
    transform: "matrix(.052 -.05 .067 .068 293 348.9)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    stroke: "#000",
    strokeWidth: 4.1,
    d: "M478.4 60.2v88.6l17.7 88.6 17.7-88.6V60.2h-35.4z",
    transform: "matrix(.052 -.05 .067 .068 311.5 319.4)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffdf00",
    stroke: "#000",
    d: "M301.2 272.8s-17.7 336.6 53.1 336.6S460.6 574 460.6 574l-.8-185-158.6-116.2z",
    transform: "matrix(-.34 0 0 .486 438.5 -20.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0000c4",
    stroke: "#000",
    d: "M344.5 304.2c0 17.7-7.9 269.8 27.5 269.8s88.6-17.7 88.6-17.7l-.8-167.3-115.3-84.8z",
    transform: "matrix(-.34 0 0 .486 438.5 -20.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e10000",
    stroke: "#000",
    d: "M367.5 321.2c0 17.7 4.5 217.4 40 217.4h53.1l-.8-149.6-92.3-67.8z",
    transform: "matrix(-.34 0 0 .486 438.5 -20.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.4 112.2 282.8 170l-1-1.2 54.7-57.7 1 1.2z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#005b00",
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M428.2-17s81.5 90.7 111 154.1c29.4 63.5 54.4 156.3 54.4 156.3s2.2-86-36.3-163C505.2 32.8 425.9-12.5 428.2-17z",
    transform: "matrix(.124 -.056 .06 .266 243.6 183.9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.2-17s81.5 90.7 111 154.1c29.4 63.5 54.4 156.3 54.4 156.3s2.2-86-36.3-163C505.2 32.8 425.9-12.5 428.2-17z",
    transform: "matrix(.148 -.04 .052 .294 230 162.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.2-17s81.5 90.7 111 154.1c29.4 63.5 54.4 156.3 54.4 156.3s2.2-86-36.3-163C505.2 32.8 425.9-12.5 428.2-17z",
    transform: "matrix(.175 .107 -.022 .3 233.8 77)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.2-17s81.5 90.7 111 154.1c29.4 63.5 54.4 156.3 54.4 156.3s2.2-86-36.3-163C505.2 32.8 425.9-12.5 428.2-17z",
    transform: "matrix(.186 .023 .012 .333 217.1 111.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.2-17s81.5 90.7 111 154.1c29.4 63.5 54.4 156.3 54.4 156.3s2.2-86-36.3-163C505.2 32.8 425.9-12.5 428.2-17z",
    transform: "matrix(.136 .126 -.028 .268 259 75.2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.2-17s81.5 90.7 111 154.1c29.4 63.5 54.4 156.3 54.4 156.3s2.2-86-36.3-163C505.2 32.8 425.9-12.5 428.2-17z",
    transform: "matrix(.17 0 .026 .304 221.8 131.7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.2-17s81.5 90.7 111 154.1c29.4 63.5 54.4 156.3 54.4 156.3s2.2-86-36.3-163C505.2 32.8 425.9-12.5 428.2-17z",
    transform: "matrix(.15 -.054 .05 .29 229 173.2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.2-17s81.5 90.7 111 154.1c29.4 63.5 54.4 156.3 54.4 156.3s2.2-86-36.3-163C505.2 32.8 425.9-12.5 428.2-17z",
    transform: "matrix(.15 -.025 .038 .298 231 150.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.2-17s81.5 90.7 111 154.1c29.4 63.5 54.4 156.3 54.4 156.3s2.2-86-36.3-163C505.2 32.8 425.9-12.5 428.2-17z",
    transform: "matrix(.168 .115 -.038 .285 240.3 74.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.2-17s81.5 90.7 111 154.1c29.4 63.5 54.4 156.3 54.4 156.3s2.2-86-36.3-163C505.2 32.8 425.9-12.5 428.2-17z",
    transform: "matrix(.184 .04 -.004 .333 220.5 98.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.2-17s81.5 90.7 111 154.1c29.4 63.5 54.4 156.3 54.4 156.3s2.2-86-36.3-163C505.2 32.8 425.9-12.5 428.2-17z",
    transform: "matrix(.128 .128 -.043 .25 265.9 77.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.2-17s81.5 90.7 111 154.1c29.4 63.5 54.4 156.3 54.4 156.3s2.2-86-36.3-163C505.2 32.8 425.9-12.5 428.2-17z",
    transform: "matrix(.18 .01 .006 .31 218.7 121.3)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#ffdf00",
    stroke: "#000",
    d: "M301.2 272.8S265.8 609.4 372 609.4c88.5 0 88.5-53.1 106.2-53.1l-17.7-124-159.4-159.5z",
    transform: "matrix(-.44 0 0 .465 485.8 17)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0000c4",
    stroke: "#000",
    d: "M336.6 308.3c0 17.7-35.4 212.6 53.2 265.7 35.4 17.7 88.5-17.7 88.5 0l-17.7-141.7-124-124z",
    transform: "matrix(-.44 0 0 .465 485.8 17)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e10000",
    stroke: "#000",
    d: "M372 343.7c0 17.7-17.7 159.4 35.5 194.9 35.4 35.4 124 25.8 124 25.8l-70.9-132.1-88.6-88.6z",
    transform: "matrix(-.44 0 0 .465 485.8 17)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m354.3 144-71.5 75.4-1.3-1.2 71.6-75.4 1.2 1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cececc",
    stroke: "#000",
    d: "m460.6 184.3 17.7 35.4v17.7c-.8-1.3 0 17.7-17.7 17.7S443 219.7 443 219.7s-17.7 35.4-17.7 70.9 17.7 53.1 17.7 53.1-2.6-36.7 17.7-35.4c20.4 1.2 17.7 17.7 17.7 17.7v35.4h17.8V219.7l17.7-35.4-27.2-53.2-26 53.1z",
    transform: "matrix(-.102 -.107 -.08 .082 428 169.7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cececc",
    stroke: "#000",
    d: "m557.8 95.7-26.3 70.8 17.7 53.2-35.4-17.7 35.4 53.1v35.5H567V255l35.5-53.1-35.5 17.7 17.8-53.2-26.9-70.8z",
    transform: "matrix(-.08 -.12 -.105 .07 407 163.4)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e10000",
    stroke: "#000",
    d: "M422.5 137c0 2-2 3.7-4.3 3.7s-4.4-1.7-4.4-3.7 2-3.8 4.4-3.8 4.3 1.7 4.3 3.8zm-6.2 7.9c0 35.8 20.9 187.8 22.6 191.5.1 4.5-4.8 6.4-7.1.9-6.6-17.4-20.8-160-21.3-193.3-.3-13.7 3.7-14.8 8.3-14.5 3.7.2 8.3 3.7 8.3 7.9 0 5-5.8 8.7-10.8 7.5z",
    transform: "matrix(-.303 0 0 .234 460 77.3)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0000c4",
    stroke: "#000",
    d: "M422.5 137c0 2-2 3.7-4.3 3.7s-4.4-1.7-4.4-3.7 2-3.8 4.4-3.8 4.3 1.7 4.3 3.8zm-6.2 7.9c31.5 61.4 48.7 166.7 50.4 170.5.1 4.4-4.8 6.4-7.1.8-2.5-3.3-12.7-100.2-49.1-172.2-.3-13.7 3.7-14.8 8.3-14.5 3.7.2 8.3 3.7 8.3 7.9 0 5-5.8 8.7-10.8 7.5z",
    transform: "matrix(-.285 .07 .114 .22 435.7 53.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e10000",
    stroke: "#000",
    d: "M422.5 137c0 2-2 3.7-4.3 3.7s-4.4-1.7-4.4-3.7 2-3.8 4.4-3.8 4.3 1.7 4.3 3.8zm-6.2 7.9c0 35.8 20.9 187.8 22.6 191.5.1 4.5-4.8 6.4-7.1.9-6.6-17.4-20.8-160-21.3-193.3-.3-13.7 3.7-14.8 8.3-14.5 3.7.2 8.3 3.7 8.3 7.9 0 5-5.8 8.7-10.8 7.5z",
    transform: "matrix(-.387 0 0 .38 511.6 87.3)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0000c4",
    stroke: "#000",
    d: "M422.5 137c0 2-2 3.7-4.3 3.7s-4.4-1.7-4.4-3.7 2-3.8 4.4-3.8 4.3 1.7 4.3 3.8zm-6.2 7.9c31.5 61.4 48.7 166.7 50.4 170.5.1 4.4-4.8 6.4-7.1.8-2.5-3.3-12.7-100.2-49.1-172.2-.3-13.7 3.7-14.8 8.3-14.5 3.7.2 8.3 3.7 8.3 7.9 0 5-5.8 8.7-10.8 7.5z",
    transform: "matrix(-.365 .112 .145 .36 480.5 48.5)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e10000",
    d: "M478.4 698a53.3 53.3 0 0 0 53.1 0V556.3h-35.4c17.7 53.1 17.7 106.3-17.8 141.7z",
    transform: "matrix(.44 0 0 .465 17.3 17)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0000c4",
    d: "M513.8 609.5c0 88.5-42.5 108.2-42.5 126 17.7 0 29.5-8.3 42.5-19.7 17.7-17.8 19.4-107.7 17.7-106.3h-17.7z",
    transform: "matrix(.265 0 0 .524 103.2 -43.2)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0000c4",
    d: "M478.4 609.5c-.9 51.7-44.8 99.6-36.5 110.2 9.4 9.5 36.5-21.7 71.9-4 17.7-17.7 19.4-107.6 17.7-106.3h-53.1z",
    transform: "matrix(.265 0 0 .524 103.2 -43.2)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffdf00",
    d: "M513.8 609.5c0 88.5-40.7 94.4-40.7 118 17.7 0 40.6-12.9 40.7-11.7 17.7-17.8 19.4-107.7 17.7-106.3h-17.7z",
    transform: "matrix(.265 0 0 .35 95 63.1)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffdf00",
    d: "M478.4 609.5c-.9 51.7-43.8 95.7-35.5 106.3 9.5 9.4 35.5-17.8 70.9 0 17.7-17.8 19.4-107.7 17.7-106.3h-53.1z",
    transform: "matrix(.265 0 0 .35 95 63.1)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e10000",
    d: "M478.4 698a53.3 53.3 0 0 0 53.1 0V556.3h-35.4c17.7 53.1 17.7 106.3-17.8 141.7z",
    transform: "matrix(-.44 0 0 .465 485.8 17)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0000c4",
    d: "M513.8 609.5c0 88.5-42.5 108.2-42.5 126 17.7 0 29.5-8.3 42.5-19.7 17.7-17.8 19.4-107.7 17.7-106.3h-17.7z",
    transform: "matrix(-.265 0 0 .524 399.9 -43.2)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0000c4",
    d: "M478.4 609.5c-.9 51.7-44.8 99.6-36.5 110.2 9.4 9.5 36.5-21.7 71.9-4 17.7-17.7 19.4-107.6 17.7-106.3h-53.1z",
    transform: "matrix(-.265 0 0 .524 399.9 -43.2)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffdf00",
    d: "M513.8 609.5c0 88.5-40.7 94.4-40.7 118 17.7 0 40.6-12.9 40.7-11.7 17.7-17.8 19.4-107.7 17.7-106.3h-17.7z",
    transform: "matrix(-.265 0 0 .35 408.2 63.1)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffdf00",
    d: "M478.4 609.5c-.9 51.7-43.8 95.7-35.5 106.3 9.5 9.4 35.5-17.8 70.9 0 17.7-17.8 19.4-107.7 17.7-106.3h-53.1z",
    transform: "matrix(-.265 0 0 .35 408.2 63.1)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#908f8a",
    strokeWidth: 4.5,
    d: "m198.6 78-89.7 35.4 89.7 35.4 44.8-17.7 22.4 17.7 22.4 35.4 22.5-35.4 22.4-17.7H1535V95.7H333l-22.4-17.8c0-17.7 4.7-35.4 22.5-35.4h89.6c0-17.7-44.8-53.1-134.5-53.1-89.6 0-134.5 35.4-134.5 53.1h89.7c17.7 0 22.4 17.7 22.4 35.5l-22.4 17.7-44.9-17.8z",
    transform: "matrix(.09 0 0 .17 174.4 269.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b74d00",
    strokeWidth: 1.8,
    d: "M204.3 95.7H541v17.7H204.4zm0-17.8H541v17.8H204.4zm0-17.7H541V78H204.4zm0-17.7H541v17.7H204.4zm0-17.7H541v17.7H204.4zm0-17.8H541v17.8H204.4zm0-17.6H541V7H204.4z",
    transform: "matrix(.21 0 0 .207 173.1 277.2)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#908f8a",
    strokeWidth: 3.3,
    d: "m423.2 60.2 137.8 124h19.7L443 60.3h-19.7z",
    transform: "matrix(.19 0 0 .207 139.8 262.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#908f8a",
    strokeWidth: 3.3,
    d: "m423.2 60.2 137.8 124h19.7L443 60.3h-19.7z",
    transform: "matrix(.19 0 0 -.207 139.8 313.1)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#908f8a",
    strokeWidth: 3.1,
    d: "M425.2 60.2v124h17.7v-124h-17.7z",
    transform: "matrix(.21 0 0 .207 130.5 262.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#908f8a",
    strokeWidth: 3.3,
    d: "m423.2 60.2 137.8 124h19.7L443 60.3h-19.7z",
    transform: "matrix(.19 0 0 .207 173.2 262.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#908f8a",
    strokeWidth: 3.3,
    d: "m423.2 60.2 137.8 124h19.7L443 60.3h-19.7z",
    transform: "matrix(.19 0 0 -.207 173.2 313.1)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#908f8a",
    strokeWidth: 3.1,
    d: "M425.2 60.2v124h17.7v-124h-17.7z",
    transform: "matrix(.21 0 0 .207 190 262.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#908f8a",
    strokeWidth: 3.1,
    d: "M425.2 60.2v124h17.7v-124h-17.7z",
    transform: "matrix(.21 0 0 .207 164 262.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#908f8a",
    strokeWidth: 3.1,
    d: "M425.2 60.2v124h17.7v-124h-17.7z",
    transform: "matrix(.21 0 0 .207 156.5 262.5)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffdf00",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M655.5 396.9c0 88-55.6 159.4-124 159.4s-124-71.4-124-159.4 55.5-159.5 124-159.5 124 71.4 124 159.4zm-17.7 0c0 78.2-47.6 141.7-106.3 141.7-58.7 0-106.3-63.5-106.3-141.7 0-78.3 47.6-141.8 106.3-141.8 58.7 0 106.3 63.5 106.3 141.8z",
    transform: "matrix(.44 0 0 .465 17.3 17)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.8 250c-14.9-8.1-31.2-12.6-48.3-12.6s-33.4 4.5-48.3 12.5l7 16.4a82.8 82.8 0 0 1 82.7 0l6.9-16.4z",
    transform: "matrix(.44 0 0 .465 17.3 17)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.8 250c-14.9-8.1-31.2-12.6-48.3-12.6s-33.4 4.5-48.3 12.5l7 16.4a82.8 82.8 0 0 1 82.7 0l6.9-16.4z",
    transform: "matrix(.44 0 0 -.465 17.4 386.4)"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#a7cfff",
    fillRule: "evenodd",
    d: "M298 201.5c0 36.4-21 65.9-46.8 65.9-25.9 0-46.8-29.5-46.8-65.9 0-36.4 21-65.9 46.8-65.9 25.8 0 46.7 29.5 46.7 65.9z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#afff7b",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M637.8 396.9c1.1 26.6-4.6 39.6-11.9 67.3-1.9 3-11-6.5-16.4-11.2s-7.8 4.2-14.6-3c-6.7-7.4-11 2-16-4.2s-51.3-7-51.3-7.6c4.6-2.2 28.2.2 24.4-11.1-4.3-11.8-31-.4-34.6-15.4-2.5-15-53.6-15.6-57.3-19.2 1.5 5.6 39.8 8 38.9 22.5-.9 6-37.7 7.7-41.3 12.7-3 6.3 29-1.7 30.1 6 0 3.2-4.7 0-21.3 5-8.4 2.5 15.4 10.3 6.4 14.6-9 4.3-28.3 6.2-27.5 8 3 9 44.7 19.6 40.6 21.1-14.8 6.6-22.6 10.9-29.7 14.7a167.9 167.9 0 0 1-31.1-100.2c31.7-11.4 25-13.8 83.6-13.8s78 2.3 129 13.8z",
    transform: "matrix(.44 0 0 .465 17.3 17)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M637.8 396.9c-8 0-16.4 3.4-25 3.4-8.7 0-17.5-3.5-26.5-3.5s-19.3 4.6-28.5 4.6c-9.3 0-17.4-4.5-26.7-4.5s-18.6 3.4-27.8 3.4-18.3-3.5-27.2-3.5-17.7 3.5-26.2 3.5-16.8-3.5-24.7-3.5c0-19.5 3-38.1 8.4-55.1 27 2 11-15.7 27-15.7a33 33 0 0 1 25.3 9.8c2.4 0 14.4-11.4 27.9-9.8 13.4 1.6 8.5 27.3 26.4 28.6 9 6.8 14.3 11.1 26.7 13.9 17.7 1.6 68.4-2.5 68.7-.2a188.2 188.2 0 0 1 2.2 28.6z",
    transform: "matrix(.44 0 0 .465 17.3 17)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M549.9 474c0-5.7 13.5-9.5 13.5-18.6s-12-9.3-12.4-17.8c-.2-3.5 10.3-7 14.9-7.4s8.5 7.4 8.5 9.1-4.7-4.2-8.6-4.3-12.3.6-12.3 2.3c0 3.4 14.8 7.6 13.7 19-1.1 11.2-12.7 14.6-12.7 18s5 12.8 5 12.8-9.7-7.5-9.7-13.2z",
    transform: "matrix(.155 0 0 .363 174 69.6)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M549.9 474c0-5.7 13.5-9.5 13.5-18.6s-12-9.3-12.4-17.8c-1-4 11.8-6.6 16.4-6.9s10 8 10 9.6-5.4-5.2-9.3-5.3-14.6.6-14.6 2.3c0 3.4 14.8 7.6 13.7 19-1.1 11.2-12.7 14.6-12.7 18s5 12.8 5 12.8-9.7-7.5-9.7-13.2z",
    transform: "matrix(-.155 0 0 .363 346.5 69.3)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M261.3 224.5c0 1-.5 1.9-1 1.9-.7 0-1.2-.8-1.2-1.9s.5-1.8 1.1-1.8c.6 0 1.1.8 1.1 1.8zm14.1 5.5h.4v14.7h-.4zm3.2-1.2h.4v14.8h-.4z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M276.1 237v-.5l3 .6v.3z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#b74d00",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M497.3 478s26 11.4 31.7 18.2c5.6 6.8 3.4 6.8 3.4 6.8l57.7 2.3c0-3.4 10.2-3.4 12.5-11.4 2.3-7.9 2.3-10.2 2.3-10.2l-18.1 5.7 1-10.2H572l-2.3 10.2-34-1.1L538 461l-6.8 1.1-1 26c-1.2 0-31.8-7.9-33-10.1z",
    transform: "matrix(.44 0 0 .465 15.3 17.5)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#fede00",
    fillRule: "evenodd",
    stroke: "#fede00",
    strokeWidth: "1pt",
    d: "M440.5 316.3s37.7-11.2 92.1-10.4 92.1 12.8 91.3 12.8-10.4-18.4-10.4-18.4-38.4-10.5-81.7-11.3c-43.2-.8-80.9 8-80 8.8l-11.3 18.5z",
    transform: "matrix(.44 0 0 .465 17.3 17)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#38a9f9",
    fillRule: "evenodd",
    d: "m241 152.8 10.3-.2v6l-10.2.2zm-23.6 3.3-3.6 5.9 12.2-1.5-1-6-7.6 1.6zm10.4-2.3 10.2-.9.5 6-10.2.9zm36.9-.6-10.2-.7-.4 6 10.2.7zm22 3.8 3.7 7.3-11-2.8 1.2-5.8 6.1 1.3zm-8.9-2.2-10.1-1.3-.7 5.9 10.1 1.3z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffdf00",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "m532.6 323.5-2.5-13.5-7.6 11.5 2.8-13.5-11.3 7.7 7.6-11.3-13.4 2.8 11.5-7.6-13.5-2.5 13.5-2.6-11.5-7.6 13.4 2.8-7.7-11.3 11.4 7.7-2.8-13.5 7.6 11.5 2.5-13.5 2.6 13.5 7.5-11.5-2.7 13.5 11.3-7.7-7.7 11.3 13.5-2.8-11.5 7.6 13.5 2.6-13.5 2.5 11.5 7.6-13.5-2.8 7.7 11.3L540 308l2.8 13.5-7.6-11.5z",
    transform: "matrix(.44 0 0 .465 17.3 17)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffdf00",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M547 293.9c0 9.3-6.6 16.8-14.8 16.8s-14.8-7.5-14.8-16.8S524 277 532.2 277s14.8 7.6 14.8 17z",
    transform: "matrix(.43 0 0 .388 23.8 41)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M252 153.4c0 .4-.9.7-2 .7s-2.2-.3-2.2-.7 1-.8 2.1-.8 2.2.4 2.2.8zm4.7 0c0 .4-.8.7-1.6.7s-1.6-.3-1.6-.7c0-.4.7-.8 1.6-.8s1.5.4 1.5.8z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "m529.4 297.9.8.8c-1.9-2-1-1.2 1.6 3.2 2.4-.5 3.1-1.4 4.8-2.4",
    transform: "matrix(.423 -.132 .125 .446 -10.1 93)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "m527.8 304.3.8.8c-1.9-2-1-1 3.2 1.6 4 .5 8.1-1.2 10.5-4",
    transform: "matrix(.44 0 0 .465 16.6 17)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#b7e1ff",
    fillRule: "evenodd",
    d: "M223.5 170.7s.7 6-4 13.5c-4.5 7.4-3.8 4.8-3.8 4.8s2.1 4 1.8 4-3.6-3.6-3.6-3.6l-3.8 4s3.5-6.3 3.1-6.3-1-2.2-1-2.2l2.8-1.1s4.2-7.8 4.2-7.5-12.7 8.6-12.7 8.6l17-14.2zm2.8 2.3c-.4 0 1.7 6 3.5 9a15 15 0 0 1 1.8 6.6l6 3-7.8-11.5 5 1.8-8.5-9zm0 15.6s4.2 4.5 4.6 6 .3 4.8.3 4.8l-1.7-3.7-2.5 3.4s1.8-5.3 1.4-5.6-2.8 1.8-2.8 1.8l1-3.3c0-.3 0-2.3-.3-3.4zM205 199.1c1.4-1.2 4.3-2 4.3-2s-1.8 3-2.2 3-1.4 0-2-1zm48.7-16.4s9.1 5.6 9.1 6-6-2.7-6-2.7l-3.1-3.3zM237.2 171c.7.4 13.4 10.8 13 10.8s-5.6-3-5.6-2.6v2.6l-2.8-6-.7 2.3-3.9-7zm3.2 16.8 3.5 7 3.5-.7s-6.7-6.3-7-6.3zm11-4.5.3 6.7s2 1.9 2 1.5-2-7.8-2.4-8.2z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#984000",
    fillRule: "evenodd",
    d: "M147.8 92.2s15.9-8.7 34-15.3a229 229 0 0 1 40.8-10.8c5.4 0 14.5 13.4 16 13.4 1.6 0 7.7-3.7 15.3-3.7s12.2 6 13.8 6h13.7c1.5 0-4.6-15 0-14.2 2.3.4 21.8 3.4 39.9 9.2 18.1 6 43.8 16.3 43.8 16.3s-42 5.6-53.2 4c-1.5.7 0 9.8-2.2 5.8-3.5-.8-16.4-2.8-18.7-2.8s-6.5 2.6-12.6 4a373.6 373.6 0 0 0-13.8 3.8l10 15.6-12.3 6s-7.6-17.9-10.7-17.9-4.5 12.7-8.4 12c-3.8-.8-5.3-12-8.3-15-3.1-3-19.2-4-25.3-5.5-6.1-1.5-16-2.7-21.3-4.2-5.3-1.5-10.7 3.8-13 3.8-2.3 0 3-4.5.8-5.3s-3.8 2.3-5.4 2.3c-1.5 0-17.5-3-19-3.8-1.6-.7 3.8-3.7 2.3-3.7h-6.1z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    fillRule: "evenodd",
    stroke: "#772600",
    strokeWidth: 3.7,
    d: "M463-65c0 21.2-20.6 38.4-45.9 38.4S371.3-43.8 371.3-65s20.5-38.3 45.8-38.3S463-86.1 463-65z",
    transform: "matrix(.165 0 0 .2 184.8 97.5)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#984000",
    fillRule: "evenodd",
    stroke: "#772600",
    strokeWidth: 5.3,
    d: "M284.7-60c6.7-6.6 15-16.6 36.7-16.6 5-1.7 5-11.7 16.6-11.7 11.7 0 8.3 10 16.7 13.4 8.3 3.3 76.6-3.4 76.6-3.4s6.6 5 6.6 11.7-5 11.6-6.6 11.6-68.3-5-73.3-3.3c-5 1.7-8.3 3.3-20 3.3-11.6 0-15-11.6-23.3-11.6s-16.6-1.7-30 6.7z",
    transform: "matrix(.206 0 0 .24 165 100.6)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#772600",
    strokeWidth: 3.5,
    d: "M487.9-76.6h26.6c9.6.1 12.9 3 21.7 3.3h23.3c8.5-.3 13-2.3 21.6-3.3 14.5-.2 9.6-1.3 6.7-10-2.6-6.5-3-9.6-6.7-13.3-1.4-8-4.6-10.8-5-20-1.5-7-4.3-11.7-1.6-20 3.8 5.7 5.3 8 15 8.4 10 0 13.9-.3 20 3.3 4.6 4.9 10.8 3.3 20 3.3 7.6 1.4 8.9 5.3 14.9 8.3 7.1 4 11.7 5 21.6 5 8 1.5 15 2.6 20 5 4.3 5.1 11 6.4 20 6.7 5 0 9-.5 13.3-1.7 7.7.4 15.5 0 25 0 6.2 7.2 7.6 9.9 18.3 10 7.4 5.2 13.6 6 20 8.3h25c9 .7 11.8 4.4 20 6.7a200.9 200.9 0 0 0 21.6 8.3 108 108 0 0 0 21.7 1.7c6.1 3.2 13.6 3.4 18.3 6.6 6.9 1.5 16.3 3.3 21.6 5 8.8 1.2 12.2 4 20 5 6.7 2-2.2 3.6-6.7 5-9.8-.3-10.5-4-20-5-5-2.9-12.6-2.5-20-5h-1.6c6.6 4 13 6.5 10 13.4-8.5 0-15.4-1.1-23.3-1.7-8.4-1.6-12.2-3.3-21.6-3.3 9.4-2.3 11.8.2 18.3 3.3 2.4 8-2.8 5-11.7 5-7.6-2.7-12.2-6-21.6-6.7h-20c9.9.4 12 4.1 18.3 8.4.5 2.6-.1 2.4-5 3.3-5.2-4.5-11.9-6-20-8.3-7.9-.3-16.2-1-23.3-3.4-4.9-.3-4.1-6.1 6.7 3.4 6.5 3.8 8.8 7 8.3 10-8.6-2.2-12.8-5.6-18.3-8.4a61.3 61.3 0 0 0-23.3-3.3c-8.6-2.3.9-3.6 6.6 5 12.4 8.8-1.6 5-6.6 3.3-7.5-2.1-15.3-5.2-21.7-6.6-5-1.5-9.4-2.9-15-3.4 8.7.8 11.6 3.9 15 10 8.8 6-.4 3.1-8.3 1.7-5-4.4-11.5-6.7-15-11.7-8.3-4.1-8.6-9-3.3 1.7 1.3 3.4 1 10.8 1.6 11.7-6.1-6.7-4.8-8.4-11.6-8.4-4.7-3.2-11.5-5.7-15-10-6.4-.6-6.8-2.9-13.3-5 5.3 6.3 12.4 12.5 16.6 18.4 7.6 4.2 9.7 8 15 11.6 2.1 3.7 8 6.7 1.7 1.7-7.2-7-12.5-8.7-23.3-13.3-6.2-5-8.4-7-15-11.7-9-2.9-5.5-4.5 0 5 6.3 5.8 11.1 12.2 16.6 16.7a67.8 67.8 0 0 0 15 13.3c1.5 2.2 6 2.6 0 3.3-5-4.6-12.4-7.5-18.3-11.7-8.3-2.3-12.2-6.6-18.3-11.6-4-5.9-10.4-10.4-15-15-9.6-3.8 1.9 3.6 5 8.3 2.1 6.1 4.8 11 6.6 16.7 2.8 5.5-8.4-1.3-11.6-3.3a57 57 0 0 0-21.7-8.4 298 298 0 0 0-20-3.3c-7.5-2 4.1 4.8 8.4 11.7 8.4 7.9-8.3 1.4-13.3 0a125 125 0 0 0-25-1.7c-10.7.6-3 2 0 6.6 3.3 2.6 5.6 8 5 10-7-1-13-3-21.7-3.3-7 2.3-15.3 1.7-23.3 1.7-.3 4.2 1.5.6 5 5 5.8 2.3 9.6 5.1 8.4 8.3h-48.3c-5.3 1.4 1.1.7 5 6.7-2.2 5.4-5 3.3-11.7 3.3-4.5-1.8-13.6-2.6-18.3-5-4.7 0-4.3-1.2-8.3-1.7 14 10 7 7.5 15 15 1.3.5 4.5 1.7 1.6 1.7M371.3 73.3c-1 0-3.2-5.4-6.6-10-2.4-6-5.4-2.6-8.4-11.7.4-9.4.7-11 0-20-6.8-4.8-9.7-6.2-15-15-8.4-7 1.3-19 2.9-27.8-7.4-1.6-11 11.5-22.3 16.2-8.2 5.5-1-11.4-5-21.2-2.7-13.9-10.8 7-13.8 12.9-5.5 3.7-7.2 8.5-15 1.6 0-5.1 4.9-19.5 2.8-22.3-7.8 3.9-18 15.5-26.1 17.3-8.2-1.7 1.7-14.8 1.7-24.5-3-1-14.7 25.8-19.5 26s-2.7-26-5-25.4c-3.5 5-10.6 15.4-15.5 19-9.5-1.3 1.4-17.5 2.8-23.5 1.6-7.2-8.9 13.8-14.5 15.1-4.1 3.6-12.2 6-15 6.7 3.2-6.2 19-18.7 18-22.3-9.3.3-23.4 12.5-31.3 14-5.2 0-12.4 1.7-13.3 1.6.4-8 19.4-14.6 22.4-19.5-9.3 1.5-27.2 9.7-32.4 16.2-6.2 1.3-14 3-20 0 .9-7.5 14.9-22 18-26.8-8.5 3.7-12.7 6.6-21.7 8.3-1.7 1.7-6.5 5.3-5 1.7 2.7-7 6.7-10 10-15-7.5 1.4-10.3 5.7-18.3 10-5.1.2-19.7 14.9-24.6 15.1a69.1 69.1 0 0 1-28.3 13.3c-7.6 1.4-11.3 3-15 6.7 3.8-6.7 9.6-13 15-16.6a29.8 29.8 0 0 1 15-13.4c1.9-2.3 7.1-2.9 1.6-3.3-4.7 4.2-12.7 9-16.6 11.7-5.1 3.2-11 6.4-13.4 5 2.7-7.2 7.5-9 11.7-15 8.8-5.6 0-2-6.7 0-4.3 3.8-12 6.7-18.3 10-7 1.8-11.7 6-20 8.3 0 2.4 2.4-4.3 3.4-6.7 6.8-7.4 8.6-9.5 16.6-11.6 2-2.9 4.4-1.7-1.6-1.7-4.6 4-10.8 6.2-16.7 10-5.9 1.3-13.6 1.7-21.6 1.7-10.4 1.2-9.5 2 0-3.4 5.3-5 9.7-3.7 10-10-6.3 4.6-14 8-21.7 11.7-6.4.2-8.1 1.7-15 1.7 3.3-3.4 5.3-7.7 10-10 7-7.7-4.4-1.5-6.7 0h-25c-4.4 5.6-.2 0 3.4-3.4 4.3-2.2 8.8-5.1 8.3-6.6-5 4.3-10.7 6.3-15 10-4.6 1.4-10 2-10 3.3 3.7-5.3 9.6-8.6 13.4-13.3 5.6-1.2 10.4-3 11.6-5h-23.3 16.6c8.5 0 15.7-.8 23.4-1.7 13.2-2.2-1.2-3.3-8.4-3.3-1.3-2.6 4.2-4 10-5C-6.7-69-.4-71.1 5-73.3a45.2 45.2 0 0 0 13.3-6.6c-5 .2-5 1.4-10 1.6 7.5-.5 12.8-1.6 21.7-1.6a239 239 0 0 0 21.6-8.3c3-3.6 4.2-3.4-3.3-3.4 6.7-2.1 16.2-3.2 21.6-5a94 94 0 0 0 20-6.6c4.9-3.3 7.7-7.2 13.3-10 6.5 4.4 6.6 5 18.3 5 9.4-.1 15.2-2.4 20-6.7 7.2-2 8.5-5.4 16.7-6.6a134 134 0 0 0 23.3 1.6c8-2.1 15.7-6 21.6-10 5.1-2.5 11.2-6.1 16.7-8.3 6 3.1 10.8 5.6 18.3 6.7 7.7-1.2 11.8-5 18.3-6.7a28 28 0 0 1 15-8.3c9.7-4.8 9 1.5 13.3 6.6 5 5.2 11.4 2.7 18.3 5 3.9 6 6.7 10 11.7 13.3 3.9 4.8 8.5 6 16.7 6.7 3 4 .6 6.8 6.6 8.3 2.4 2.6 6.5 3.6 10 5",
    transform: "matrix(.206 0 0 .24 165 103.8)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#782600",
    strokeWidth: 3.1,
    d: "M468.7 30.8v.8c0-2.3 0-1 1.7 3.4.6 3.6-.8 3.2-2.5 5.8-.3 3.7-.8 6.4-.8 10.8-.6 3.6-2.6 7-4.2 10-1.6 3.1-8.5 4.9-8.3 9.2-4 1.1-4.1-1.5-4.2-5.9-2.4-2.7-3.2-6.4-5-10-1-3.4-3.4-6-5-10-2.4-3.7-4.5-4.8-6.6-9.1-.9-2-.7-4.6-2.5-5.8-2.7-3.5-4.5-4-9.2-4.2-3.6.8-5 2.4-8.3 3.3-2.6.9-7.6.6-10.8 1.7-.8 1.3 1.6 2 2.5 5-2.2 1.8-3 4.9-4.2 7.5-2 2.5-3.3 3.7-4.2 7.5 1.4 2.3.2 5.4-1.6 7.5-.6 3.8-2.5 5.9-3.4 9.1-2.6 1.9-3.6 3.6-5.8 6.7-1.9 2.7-3.6 2.5-8.3 2.5-3.7-1-4.2-3-7.5-4.2-.3-1-.6-1.3-1.7-1.6",
    transform: "matrix(.206 0 0 .24 165 103.8)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#812e00",
    fillRule: "evenodd",
    d: "M242.2 119.4s-.3 3.7-2.7 6.2-7.4 5.4-7.4 5.4 6.7-3.1 7.4-2.5c.7.7-4.3 6.3-4.3 6.3s6.5-5.9 7.4-5.9 2.7 5.7 3.4 5.6c.7-.1-1.5-7.2-1.2-8.3.3-1.1 0-7 0-7l-2.6.2zm15.5-.5s-.3 4-2.8 6.6-7.4 5.8-7.4 5.8 6.8-3.4 7.4-2.6c.7.7-4.3 6.6-4.3 6.6s6.6-6.2 7.4-6.2 2.8 6 3.5 6c.7-.2-1.6-7.8-1.2-9 .3-1.1 0-7.5 0-7.5l-2.6.3zM236 82.6c0 .8-.7 1.4-1.6 1.4s-1.6-.6-1.6-1.4.7-1.3 1.6-1.3 1.6.6 1.6 1.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEc);
export default __webpack_public_path__ + "static/media/ec.33ce56273543deb46e2cdb7663a89421.svg";
export { ForwardRef as ReactComponent };